'use client'

import { motion } from 'framer-motion'
import Image from "next/image";

export default function DressCode() {
	return (
		<section id="dress-code" className="py-10 md:py-20 px-4 section-bg-dark">
			<div className="container mx-auto">
				<motion.div
					initial={{ opacity: 0, y: 50 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
					className="max-w-7xl mx-auto"
				>
					{/* Mood board principal */}
					<motion.div
						className="relative group cursor-pointer"
						whileHover={{ scale: 1.02 }}
						transition={{ duration: 0.3 }}
					>
						<div className="relative overflow-hidden rounded-2xl shadow-2xl">
							<div className="relative aspect-[16/10] overflow-hidden">
								<Image
									src="/img/Moodboard.png"
									alt="MoodBoard - Dress Code Inspiration"
									fill
									className="object-cover transition-transform duration-700 group-hover:scale-105"
									priority
								/>
							</div>
						</div>

						{/* Bordure lumineuse au hover */}
						<div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-white/20 transition-colors duration-300" />
					</motion.div>
				</motion.div>
			</div>
		</section>
	)
}
